<div class="h-100" [ngSwitch]="currentType">
  <df-dance-manager-public-page *ngSwitchCase="partnerTypeEnum.danceSchool" [urlName]="urlName" [isDmPreview]="false"></df-dance-manager-public-page>
  <df-user-app-profile *ngSwitchCase="partnerTypeEnum.user" [userUrlName]="urlName"></df-user-app-profile>
</div>
